export const MAX_VISIBLE_FACET_COUNT = 5
